<template>
  <div>
    <span class="text-xl" :class="fontClass">{{ personalizationText }}</span>
    <p v-if="hasHelperText" class="italic mt-3" v-html="bp('personalizeMessage')" />
  </div>
</template>

<script>
export default {
  props: {
    personalizationText: {
      type: String,
      required: true,
    },
    hasHelperText: {
      type: Boolean,
      default: true,
    },
    fontChoiceId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      fontChoiceIdMap: {
        2803: 'ultra',
        2804: 'standard',
        2805: 'ornate',
      },
    };
  },

  computed: {
    fontClass() {
      return this.fontChoiceIdMap[this.fontChoiceId];
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: Standard;
  font-weight: 400;
  font-style: normal;
  src: url(https://trekcdnprod.azureedge.net/hybris/fonts/RingsideCompressed-Bold.otf) format('opentype');
}
@font-face {
  font-family: Ultra;
  font-weight: 400;
  font-style: normal;
  src: url(https://trekcdnprod.azureedge.net/hybris/fonts/RingsideNarrow-UltraItalic.otf) format('opentype');
  font-display: swap;
}
@font-face {
  font-family: Ornate;
  font-weight: 400;
  font-style: normal;
  src: url(https://trekcdnprod.azureedge.net/hybris/fonts/CooperNouveau.otf) format('opentype');
  font-display: swap;
}
.standard {
  font-family: Standard;
}

.ultra {
  font-family: Ultra;
}

.ornate {
  font-family: Ornate;
}
</style>
